import { BaseFacility } from '@gyym/sdk'
import React from 'react'

import { FacilityCardList } from '@/components/UI/FacilityCardList'

import { Container } from './styles'

export interface FacilityListViewProps {
  facilities: BaseFacility[]
}

export const FacilityListView = ({ facilities }: FacilityListViewProps) => {
  return (
    <Container>
      <FacilityCardList facilities={facilities} />
    </Container>
  )
}
